const WIDGET_CONFIG_API_BASE_URL = process.env.donate_widget_services_widget_config_api_base_url;
const OCP_APIM_SUBSCRIPTION_KEY = process.env.donate_widget_ocp_apim_subscription_key;

async function getWidgetConfigById(widgetId) {
  if (!WIDGET_CONFIG_API_BASE_URL) {
    throw new Error("WIDGET_CONFIG_API_BASE_URL is not set");
  }
  return new Promise((resolve, reject) => {
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 15 * 1000);

    const requestOpts = {
      method: "GET",
      headers: {
        "Ocp-Apim-Subscription-Key": OCP_APIM_SUBSCRIPTION_KEY
      },
      signal: controller.signal
    };

    const widgetType = "donate-widget";

    const request = new Request(
      `${WIDGET_CONFIG_API_BASE_URL}/widgets/${widgetId}?widgetType=${widgetType}`,
      requestOpts
    );

    fetch(request)
      .then((resp) => {
        clearTimeout(timeoutId);
        if (!resp.ok) {
          throw new Error(`Widget Id: ${widgetId} -> ${resp.status} ${resp.statusText}`);
        }
        return resp.json();
      })
      .then((data) => {
        const widgetConfig = data?.widgetConfig ? data?.widgetConfig[0] : {};
        if (!widgetConfig?.widgetId || !widgetConfig.donateURL) {
          throw new Error("Invalid Donate Config");
        }

        resolve(widgetConfig);
      })
      .catch((err) => {
        clearTimeout(timeoutId);
        reject(err);
      });
  });
}

export default getWidgetConfigById;
